import React, { useState } from "react";
import Avatar from "components/Avatar";
import { ReactComponent as AddCamera } from "assets/img/icons/camera.svg";
import UserService from "services/UserService";
import ImageSelectAndCrop from "components/ImageSelectAndCrop";
import { useToasts } from "react-toast-notifications";
import UserDefaultAvatar from "assets/img/user.svg";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { useUserContext } from "store/contexts/userContext";
import ImageDisplay from "components/AttachmentPreview/Display/ImageDisplay";
import { ReactComponent as DeleteIcon } from "assets/img/icons/Delete.svg";
import { useGlobalContext } from "store/contexts/globalContext";

const styles = {
  avatarContainer: {
    height: "100px",
    width: "100px",
    position: "absolute",
    bottom: "-30px",
    left: "10px",
    zIndex: "10",
  },
  avatar: {
    height: "100px",
    width: "100px",
    zIndex: "10",
    boxShadow:
      "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
  },
  updateProfilePicture: {
    position: "absolute",
    bottom: "0",
    right: "10px",
    zIndex: "10",
    boxShadow:
      "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
    cursor: "pointer",
    color: "black",
    width: "24px",
    height: "24px",
  },
  deleteProfilePicture: {
    position: "absolute",
    bottom: "0",
    left: "0",
    zIndex: "10",
    boxShadow:
      "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
    cursor: "pointer",
    color: "black",
    width: "24px",
    height: "24px",
  },
  attachmentFile: {
    display: "none",
  },
  uploadingOverlay: {
    height: "100px",
    width: "100px",
    position: "absolute",
    zIndex: "101",
    background: "#000a",
    color: "white",
    fontWeight: "400",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    cursor: "pointer",
  },
  previewDialog: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "1100",
    color: "black",
  },
  previewDialogBackdrop: {
    height: "inherit",
    width: "inherit",
    position: "fixed",
    backgroundColor: "black",
    top: "0",
    left: "0",
    zIndex: "-1",
    pointerEvents: "none",
    opacity: "0.7",
  },
  contentContainer: {
    maxHeight: "70vh",
    maxWidth: "80vh",
    display: "flex",
    justifyContent: "center",
    position: "relative",
  },
  closeIcon: {
    width: "25px",
    cursor: "pointer",
    fill: "white",
  },

  closeContainer: {
    padding: "20px",
    position: "absolute",
    top: 0,
    right: 0,
  },
};

export default ({ profile, setProfile, isOwner }) => {
  const classes = styles;
  const { addToast } = useToasts();
  const [isUpdating, setIsUpdating] = useState(false);
  const [showPreviewDialog, setShowPreviewDialog] = useState(false);
  const { user, setUser } = useUserContext();
  const { microsoftConfigureTab } = useGlobalContext();

  const updateAvatar = async (file) => {
    setIsUpdating(true);

    try {
      await UserService.updateUserAvatar(file);
      addToast("User avatar updated successfully.", {
        appearance: "success",
      });
      setUser({
        ...user,
        avatar: file !== null ? URL.createObjectURL(file) : null,
      });
    } catch (error) {}

    setIsUpdating(false);
    setProfile({
      ...profile,
      avatar: file !== null ? URL.createObjectURL(file) : null,
    });
  };

  const preventDefaultOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  };

  const showAvatar = (event) => {
    if (profile.avatar) {
      if (!microsoftConfigureTab) {
        document.getElementById("footer").style.zIndex = "-1";
      }
      document.getElementById("header").style.zIndex = "-1";
      setShowPreviewDialog(true);
      event.preventDefault();
      return;
    }
    return;
  };

  const closePreviewDailog = () => {
    if (!microsoftConfigureTab) {
      document.getElementById("footer").style.zIndex = "1";
    }

    document.getElementById("header").style.zIndex = "1";
    setShowPreviewDialog(false);
  };

  return (
    <>
      <div style={classes.avatarContainer} id="avatar">
        {isUpdating && (
          <div style={classes.uploadingOverlay}>
            <span>Uploading...</span>
          </div>
        )}
        <div>
          <Avatar
            className={!profile.is_default_avatar ? "cursor" : "notClickAble"}
            rootStyle={classes.avatar}
            onClick={showAvatar}
            src={profile.avatar ?? UserDefaultAvatar}
          ></Avatar>
          {isOwner && (
            <ImageSelectAndCrop aspect={4 / 3} onUpdate={updateAvatar}>
              <AddCamera style={classes.updateProfilePicture}></AddCamera>
            </ImageSelectAndCrop>
          )}
        </div>
        {!profile.is_default_avatar && isOwner && (
          <DeleteIcon
            onClick={() => updateAvatar(null)}
            style={classes.deleteProfilePicture}
          ></DeleteIcon>
        )}
      </div>
      {showPreviewDialog && (
        <div style={classes.previewDialog} onClick={closePreviewDailog}>
          <div style={classes.previewDialogBackdrop}></div>
          <div style={classes.closeContainer}>
            <CloseIcon style={classes.closeIcon} onClick={closePreviewDailog} />
          </div>
          <div
            className="imagePreviewContentContainer"
            onClick={preventDefaultOnClick}
          >
            <ImageDisplay attachmentSrc={profile.avatar} />
          </div>
        </div>
      )}
    </>
  );
};
